exports.info = {
  title: 'Lets Movie｜電影約會交友｜女生免費看電影',
  description: '不想一個人去電影院？來 Lets Movie 找人一起看場電影吧！討論碰面時間地點，24小時內結束對話，不讓你尬聊，不用勉強自己當個Social咖。讓你面對面認識一個真心的朋友，有些人就是面對面了才了解他/她的好，有些人就是不擅長在網路上包裝自己，一起看場電影吧。在故事中大冒險，也可能發覺這個人，比電影故事還精彩',
  keywords: '約會 看電影，找人看電影，男女看電影，約會交友，電影約會',
}
